import { FC, useState } from 'react';

import { useAuth } from '../../contexts/AuthContext';
import Button from '../components/Button';
import PageContainer from '../components/Containers/PageContainer';
import { logger } from '../../lib/logger';

const UnsupportedLegacyAccount: FC = () => {
  const { logout } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const handleLogout = async () => {
    setIsLoggingOut(true);
    setErrorMessage(undefined);
    try {
      await logout();
    } catch (error) {
      logger.error('Failed to log out from unsupported legacy account page', {
        error: error instanceof Error ? error : new Error(String(error)),
      });
      setErrorMessage('Could not log out. Please try again.');
      setIsLoggingOut(false);
    }
  };

  return (
    <PageContainer containerClassName="h-screen items-center justify-center">
      <div className="flex max-w-md flex-col items-start gap-6">
        <div className="flex flex-col gap-3">
          <h1 className="text-big-label font-bold text-neutral-150">
            This account isn't supported in the current app
          </h1>
          <p className="text-body text-neutral-125">
            You're signed in with a legacy Homecoming account. This version of
            the product is no longer available here.
          </p>
          <p className="text-body text-neutral-125">
            Please contact Homecoming support to migrate your account, or log
            out and sign in with a different account.
          </p>
        </div>

        {errorMessage && (
          <p className="text-caption text-red-100">{errorMessage}</p>
        )}

        <Button
          title={isLoggingOut ? 'Logging out…' : 'Log out'}
          theme="primary"
          size="medium"
          disabled={isLoggingOut}
          onClick={handleLogout}
        />
      </div>
    </PageContainer>
  );
};

export default UnsupportedLegacyAccount;
